import { __assign } from "tslib";
import { get, round } from 'lodash';
import { hasPlaceholder } from '@wix/shoutout-email-model-v3';
import { SectionType } from '../../types';
import { getMessageWidth } from '../../utils/get-message-width';
import { getSectionMarginAsObject, getSectionPaddingAsObject, } from '../../utils/get-section-padding';
import { addHttps } from '../../utils/add-https';
import { getImageSrc, isGif, getImageWidth } from '../get-image/image-utils';
var AVATAR_SIZE = 60;
var WIDTH_AUTO = 'auto';
var getImageHeightIfAvailable = function (region, newWidth) {
    var width = get(region, 'data.width', false);
    var height = get(region, 'data.height', false);
    if (width && height && newWidth !== WIDTH_AUTO) {
        return round((height / width) * newWidth);
    }
    return undefined;
};
export var getImageMaxWidth = function (_a) {
    var composerData = _a.composerData, columnPadding = _a.columnPadding, numberOfColumns = _a.numberOfColumns, columnWidth = _a.columnWidth, userOverrides = _a.userOverrides;
    var messageContentWidth = getMessageWidth(composerData, composerData.styles.css);
    var _b = getSectionPaddingAsObject(composerData.styles.css, SectionType.mix, userOverrides), paddingLeft = _b.left, paddingRight = _b.right;
    var _c = getSectionMarginAsObject(composerData.styles.css, SectionType.mix), marginLeft = _c.left, marginRight = _c.right;
    var mixRegionWidth = messageContentWidth -
        (paddingLeft || 0) -
        (paddingRight || 0) -
        (marginRight || 0) -
        (marginLeft || 0);
    var spacesBetweenColumns = parseInt(columnPadding, 10) * 2 * (numberOfColumns - 1);
    var actualRegionWidth = mixRegionWidth - spacesBetweenColumns;
    return Math.floor((actualRegionWidth / 100) * columnWidth);
};
export var getImage = function (_a) {
    var region = _a.region, composerData = _a.composerData, getColumnOfRegion = _a.getColumnOfRegion, _b = _a.numberOfColumns, numberOfColumns = _b === void 0 ? 2 : _b, _c = _a.columnWidth, columnWidth = _c === void 0 ? 50 : _c, _d = _a.balancedColumnPaddings, balancedColumnPaddings = _d === void 0 ? { left: 0, right: 0 } : _d, userOverrides = _a.userOverrides, replaceImagePlaceholders = _a.replaceImagePlaceholders;
    var column = getColumnOfRegion();
    var columnPadding = balancedColumnPaddings[column] || balancedColumnPaddings.left;
    var maxWidth = getImageMaxWidth({
        composerData: composerData,
        numberOfColumns: numberOfColumns,
        columnPadding: columnPadding,
        columnWidth: columnWidth,
        userOverrides: userOverrides,
    });
    var naturalImageWidth = region.data.width ? region.data.width : maxWidth;
    var maxContentWidth = naturalImageWidth >= maxWidth ? maxWidth : naturalImageWidth;
    var src = getImageSrc({
        region: region,
        fallbackUrl: composerData.styles.settings.image.url,
        maxContentWidth: maxContentWidth,
        isMix: true,
        replaceImagePlaceholders: replaceImagePlaceholders,
    });
    var imageWidth = getImageWidth(region, maxContentWidth);
    var imageProps = {};
    if (region.data.placeholderPreviewType === 'avatar') {
        imageProps.width = AVATAR_SIZE;
        imageProps.height = AVATAR_SIZE;
        imageProps.imgStyle = {
            borderRadius: '100%',
            height: AVATAR_SIZE + "px",
        };
    }
    else {
        imageProps.width = imageWidth;
        if (isGif(src)) {
            imageProps.height = getImageHeightIfAvailable(region, imageProps.width);
        }
    }
    var srcPlaceholder = region.data.relativeUri || region.data.url;
    return __assign({ type: 'image', regionId: region.regionId, src: addHttps(src), srcPlaceholder: hasPlaceholder(srcPlaceholder) ? srcPlaceholder : '', link: region.data.imageLink }, imageProps);
};
//# sourceMappingURL=get-image.js.map